import config from "@/config";
import http from "@/utils/request";

export default {
	sign: {
		getConfig: {
			url: `${config.API_URL}/admin/sign/getConfig`,
			name: "获取签到配置",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		updateConfig: {
			url: `${config.API_URL}/admin/sign/updateConfig`,
			name: "设置签到配置",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		getRewardList: {
			url: `${config.API_URL}/admin/sign/getRewardList`,
			name: "获取签到奖励列表",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		getRewardDetail: {
			url: `${config.API_URL}/admin/sign/getRewardDetail`,
			name: "获取签到奖励详情",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		addReward: {
			url: `${config.API_URL}/admin/sign/addReward`,
			name: "添加签到奖励配置",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		updateReward: {
			url: `${config.API_URL}/admin/sign/updateReward`,
			name: "修改签到奖励配置",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		deleteReward: {
			url: `${config.API_URL}/admin/sign/deleteReward`,
			name: "删除签到奖励配置",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	category: {
		list: {
			url: `${config.API_URL}/admin/points_exchange_category/getList`,
			name: "获取积分兑换分类列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/points_exchange_category/detail`,
			name: "获取积分兑换分类详情",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		create: {
			url: `${config.API_URL}/admin/points_exchange_category/create`,
			name: "创建积分兑换分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/points_exchange_category/update`,
			name: "更新积分兑换分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/points_exchange_category/delete`,
			name: "删除积分兑换分类",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	exchange: {
		getList: {
			url: `${config.API_URL}/admin/points_exchange/getList`,
			name: "获取积分兑换列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		create: {
			url: `${config.API_URL}/admin/points_exchange/create`,
			name: "添加积分兑换商品",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/points_exchange/update`,
			name: "更新积分兑换商品",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/points_exchange/delete`,
			name: "删除积分兑换商品",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		updateStatus: {
			url: `${config.API_URL}/admin/points_exchange/updateStatus`,
			name: "更新积分兑换状态",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
};
